<script setup lang="ts">
import { computed } from 'vue'
import { useDisplay } from 'vuetify'

type AllowedColors = 'success' | 'error' | 'alert' | 'green'

const props = defineProps<{
  color?: AllowedColors
  icon?: string
}>()

// Detecta mobile via Vuetify
const { mobile } = useDisplay()
const isMobile = computed(() => mobile.value)

// Cor da barra superior
const backgroundColor = computed(() =>
  props.color ? `var(--v-theme-${props.color})` : undefined
)

// Padding responsivo
const cardPaddingClass = computed(() => (isMobile.value ? 'pa-4' : 'pa-6'))
</script>

<template>
  <v-card
    class="position-relative d-flex flex-column align-center justify-center rounded-lg"
    :class="cardPaddingClass"
  >
    <!-- Barra Superior Colorida -->
    <div
      v-if="props.color"
      class="w-100 rounded-t-lg"
      :style="{ backgroundColor, height: '8px' }"
    />

    <!-- Conteúdo -->
    <slot />
  </v-card>
</template>
